import { NgModule, APP_INITIALIZER } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { HttpModule } from '@angular/http'
import { FormsModule } from '@angular/forms'

import { RoutingModule } from './routing.module'
import { SuiModule } from 'ng2-semantic-ui'
import { DateTimePickerModule } from 'ng-pick-datetime'
import { FlexLayoutModule } from '@angular/flex-layout'
import { AgmCoreModule } from '@agm/core'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { CKEditorModule } from 'ng2-ckeditor'

import { AppComponent } from './components/app/app.component'
import { HomeComponent } from './components/home/home.component'
import { LoginComponent } from './components/login/login.component'
import { EventsListComponent } from './components/events-list/events-list.component'
import { EventFormComponent } from './components/event-form/event-form.component'
import { UsersListComponent } from './components/users-list/users-list.component'
import { UserComponent } from './components/user/user.component'
import { EventComponent } from './components/event/event.component'
import { UserFormComponent } from './components/user-form/user-form.component'
import { LayoutComponent } from './components/layout/layout.component'
import { NavComponent } from './components/nav/nav.component'
import { MessagesComponent } from './components/messages/messages.component'
import { LoadingComponent } from './components/loading/loading.component'
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component'
import { CalendarComponent } from './components/calendar/calendar.component'
import { NotFoundComponent } from './components/not-found/not-found.component'
import { UserRelationComponent } from './components/user-relation/user-relation.component'
import { SelectRelationshipComponent } from './components/select-relationship/select-relationship.component'
import { SelectUserComponent } from './components/select-user/select-user.component'
import { SelectUserMultipleComponent } from './components/select-user-multiple/select-user-multiple.component'
import { SelectGroupMultipleComponent } from './components/select-group-multiple/select-group-multiple.component'
import { TreesComponent } from './components/trees/trees.component'
import { GroupsFormComponent } from './components/groups-form/groups-form.component'
import { GroupComponent } from './components/group/group.component'
import { GroupsListComponent } from './components/groups-list/groups-list.component'
import { GroupMembersComponent } from './components/group-members/group-members.component'
import { PicturesViewerComponent } from './components/pictures-viewer/pictures-viewer.component'
import { CommentFormComponent } from './components/comment-form/comment-form.component'
import { EventMapComponent } from './components/event-map/event-map.component'
import { EventDateComponent } from './components/event-date/event-date.component'
import { UserAvatarComponent } from './components/user-avatar/user-avatar.component'
import { ContentSafeComponent } from './components/content-safe/content-safe.component'

import { NotNullPipe } from './pipes/notNull.pipe'
import { EventsFilterPipe } from './pipes/events-filter.pipe'
import { TextEllipsisPipe } from './pipes/text-ellipsis.pipe'
import { ToTimezonePipe } from './pipes/to-timezone.pipe'

import { LOCALE_ID } from '@angular/core'
import { AuthService } from './services/auth.service'
import { UsersService } from './services/users.service'
import { ApiService } from './services/api.service'
import { MessagesDelegate } from './services/messages-delegate.service'
import { LoadingDelegate } from './services/loading-delegate.service'
import { EventsService } from './services/events.service'
import { StartupService } from './services/startup.service'
import { EventsEmitterService } from './services/events-emitter.service'
import { CalendarService } from './services/calendar.service'
import { GroupsService } from './services/groups.service'
import { ParserService } from './services/parser.service'

import { MainGuard } from './guards/main.guard'
import { AdminGuard } from './guards/admin.guard'

import { config } from './config/config'

// async provider, following https://gist.github.com/fernandohu/122e88c3bcd210bbe41c608c36306db9
const initUser = (startupService: StartupService): Function => {
  return () => startupService.init()
}

@NgModule({
  imports: [
    BrowserModule,
    HttpModule,
    FormsModule,
    RoutingModule,
    SuiModule,
    DateTimePickerModule,
    FlexLayoutModule,
    AgmCoreModule.forRoot({
      apiKey: config.googleMap.apiKey
    }),
    BrowserAnimationsModule,
    CKEditorModule
  ],
  declarations: [
    NotNullPipe,
    EventsFilterPipe,
    TextEllipsisPipe,
    ToTimezonePipe,
    AppComponent,
    HomeComponent,
    LoginComponent,
    LayoutComponent,
    EventsListComponent,
    EventComponent,
    EventFormComponent,
    UsersListComponent,
    UserComponent,
    UserFormComponent,
    NavComponent,
    MessagesComponent,
    LoadingComponent,
    ConfirmModalComponent,
    CalendarComponent,
    NotFoundComponent,
    UserRelationComponent,
    SelectRelationshipComponent,
    SelectUserComponent,
    SelectUserMultipleComponent,
    SelectGroupMultipleComponent,
    TreesComponent,
    GroupsFormComponent,
    GroupsListComponent,
    GroupComponent,
    GroupMembersComponent,
    PicturesViewerComponent,
    CommentFormComponent,
    ContentSafeComponent,
    EventMapComponent,
    EventDateComponent,
    UserAvatarComponent
  ],
  entryComponents: [
    ConfirmModalComponent
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    AuthService,
    UsersService,
    ApiService,
    MessagesDelegate,
    LoadingDelegate,
    EventsService,
    EventsEmitterService,
    GroupsService,
    MainGuard,
    AdminGuard,
    StartupService,
    ParserService,
    {
      provide: APP_INITIALIZER,
      useFactory: initUser,
      deps: [StartupService],
      multi: true
    }
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule {
  constructor (private ApiService: ApiService, private loadingDelegate: LoadingDelegate) {
    this.ApiService.setBeforeQuery(this.loadingDelegate.show)
    this.ApiService.setAfterQuery(this.loadingDelegate.hide)
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/app.module.ts